import styled, { css } from "styled-components";
import { COLOR_BLACK, COLOR_WHITE } from "../../../constants/colors";

export const PaymentMethod = styled.div<{ isSelected: boolean }>`
  border-radius: 10px;
  padding: 30px;
  transition: 500ms;
  width: 75%;
  cursor: pointer;

  div {
    color: ${COLOR_WHITE};
  }

  ${({ isSelected }) =>
    isSelected &&
    css`
      cursor: default;
      transform: translate(-10px, -10px);
      box-shadow: 10px 10px 20px black;
    `}

  @media (max-width: 768px) {
    width: 100%;
    padding: 10px;
  }
`;

export const PaymentImage = styled.img`
  background-color: white;
  border-radius: 11%;
  width: 85px;
  height: 85px;

  @media (max-width: 768px) {
    width: 60px;
    height: 60px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${COLOR_BLACK};
  margin-top: 40px;
  margin-bottom: 20px;
`;
